import { render, staticRenderFns } from "./UploadBtn.vue?vue&type=template&id=053be999"
import script from "./UploadBtn.vue?vue&type=script&lang=js"
export * from "./UploadBtn.vue?vue&type=script&lang=js"
import style0 from "./UploadBtn.vue?vue&type=style&index=0&id=053be999&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports